import React from "react"
import { Typography } from "@mui/material"


export default function idColumn() {
	return {
		name: 'id_batch',
		label: 'Batch ID',
		options: {
			filterType: "textField",
			customBodyRowRenderLite: value => <Typography
				sx={{ textAlign: "center" }}>{value}</Typography>
		}
	}
}